export enum InsightTerm {
  Behavior = 89,
  Assesment = 90,
  Strategy = 91,
  Data = 92,
}

export enum TabIndex {
  Behavior = 1,
  Assesment = 2,
  Strategy = 3,
  Data = 4,
  'Review Email' = 5,
}

export enum ReviewStatus {
  'No Behavior Defined' = 97,
  'Review Pending' = 93,
  'Changes Requested' = 94,
  'Changes Received' = 95,
  'Completed' = 96,
}
